import alphanumeric from "./alphanumeric";

export const message = (errorType, field, args = {}) => {
  const message = {
    Email: `Please use valid email address! Usually using “@mail.com”.`,
    Empty: `${field} must empty`,
    NotEmpty: `You can’t leave this ${field} empty`,
    Numeric: `${field} must be numeric value`,
    Phone: `${field} must be numeric/phone value`,
    MaxLength: `${field} max ${args.len} characters`,
    MinLength: `${field} min ${args.len} characters`,
    Checked: `${field} must be checked`,
    Selected: `${field} must be selected`,
    Url: `Please use valid URL! `,
    Alphanumeric: `${field} must be alphanumeric value`,
    NewMaxLength: `${field} can't max than ${args.len} characters`,
    NewMinLength: `${field} must be at least ${args.len} characters`,
    NewNotEmpty: `This field is required! Please enter ${field}`,
    MaxValue: `For ${field} maximum value can't be higher than ${args.len}`,
    MinValue: `For ${field} minimum value can't be lower than ${args.len}`,
  }
  return message[errorType]
}

export const debounce = (fn, delay) => {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}

const errorMessages = (type, field, value = null, message = null) => {
  /**
   * @todo Add new message if necessary. Type is vuelidate built in validators
   */
  if (type === 'required') return `The field is required! Please enter ${field}`
  if (type === 'minLength') return `${field} must be at least ${value} characters`
  if (type === 'maxLength') return `${field} can't max than ${value} characters`
  if (type === 'alpha') return `${field} must be alphabet value`
  if (type === 'alphaNum') return `${field} must be alphanumeric value`
  if (type === 'numeric') return `${field} must be numeric value`
  if (type === 'email') return `Please use valid email address! Usually using “@mail.com”.`
  if (type === 'url') return `Please use valid URL! `
  if (type === 'maxValue') return `For ${field} maximum value can't be higher than ${value}`
  if (type === 'minValue') return `For ${field} minimum value can't be lower than ${value}`
  if (type === 'requiredIf') return `The field is required! Please enter ${field}`
  if (type === 'custom') return message

  // Handle invalid type with generic error message
  return `validation error`
}

export const vuelidateErrorMessage = (validation, field = null, customMessage = null) => {
  /**
   * @param {object}          validation        Vuelidate object contains validation property for each field.
   * @param {string}          field             Field name that you want to show at error message.
   * @param {string/object}   customMessage     Pass string if you want to use single error message for all kind of validation.
   *                                            Pass object if you want to custom each of validation message.
   *                                            The property is vuelidate built in validators.
   *                                            e.g.,  { required: 'this field is required', minLength: 'value min 3!'}
   */

  for (let key in validation) {

    if (!key.includes('$') && validation[key] === false) {
      let value
      let message

      // Handle custom messages
      if (customMessage) {
        if (typeof customMessage === 'object') {
          message = customMessage[key]
        } else {
          message = customMessage
        }
        
        if (message) key = 'custom'
      }

      // Get value from params
      if (key === 'maxLength') {
        value = validation.$params[key].max
      } else if (key === 'minLength') {
        value = validation.$params[key].min
      }
      
      return errorMessages(key, field, value, message)
    } else if (key.includes('$each') && validation.$invalid === true) {
      // Handle vuelidate collection validations
      let message = customMessage
      let key = 'custom'
      
      return errorMessages(key, field, null, message)
    }
  }
}

export const vuelidateValidationHelper = (model, options, refs) => {
  /**
   * @param {object}   model                    Vuelidate object contains model property for each field.
   * @param {object}   options                  Object that contains every field informations required for this helper.
   *                                            e.g.,  options: { 
   *                                                      fieldA: { field: 'name', error: null, ref: 'fieldA'},
   *                                                      fieldB: { message: { required: 'this is wajib!' } , field: 'description', error: null}
   *                                                   }
   * @param {object}   options.fieldA           Name of the field.
   * @param {object}   options.fieldA.message   Custom message for all kind of validation of selected field.
   * @param {object}   options.fieldA.field     Field's name on error message.
   * @param {object}   options.fieldA.error     Field's error message.
   * @param {object}   options.fieldA.ref       Field's ref for focusing the field location if there is error. The value should be the same as field's name
   * @param {object}   options.fieldA.pair      Number of object property in vuelidate collection. Pair is mandatory when using a vuelidate collection.
   */

  for (let key in model) {
    if (!key.includes('$')) {
      
      // Stop loop is there's error.
      if (model[key].$error) {
        let collection = false

        // Check if key is vuelidate collection.
        if (!model[key].hasOwnProperty('$each')) {
          let element = null
          let fieldName = options[key].hasOwnProperty('field') ? options[key].field : key
          let customMessage = options[key].hasOwnProperty('message') ? options[key].message : null
          let message = vuelidateErrorMessage(model[key], fieldName, customMessage)
  
          // Safely check ref property and focus to it afterward.
          if (options[key].hasOwnProperty('ref')) {
            let ref = refs[key]
            element = ref

            if (ref.hasOwnProperty('$el')) {
              element = ref.$el
            }
            return { key, message, element, collection }
          }
  
          return { key, message, element, collection }
        } else {

          for (let index in model[key].$each) {
            if (!key.includes('$')) {

              for (let collectionKey in model[key].$each[index]) {
                if (!key.includes('$')) {

                  if (model[key].$each[index][collectionKey].$error) {
                    let fieldName = options[key].hasOwnProperty('field') ? options[key].field[collectionKey] : key
                    let customMessage = options[key].hasOwnProperty('message') ? options[key].message : null
                    let message = vuelidateErrorMessage(model[key].$each[index][collectionKey], fieldName, customMessage)
                    let element = null

                    // Safely check ref property and focus to it afterward.
                    if (options[key].hasOwnProperty('ref')) {
                      let ref = refs[collectionKey]
                      element = ref
                      
                      // Check if the ref return an array. This happen when the ref is inside v-for
                      if (refs[collectionKey][0] !== undefined) {
                        ref = ref[index]
                        collection = { index, collectionKey }
                      }
                      
                      if (ref.hasOwnProperty('$el')) {
                        element = ref.$el
                      }
                      return { key, message, element, collection }
                    }
                    return { key, message, element, collection }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}